import { fillString } from '@local_modules/generic/string-template.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'

import { callApi } from '@local_modules/generic/fetch.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { showTableChartsOfAccounts } from './show-table.js'
import { showMenu } from './show-menu.js'

import { loadChartOfAccounts } from '../../../../helpers/app-data-loaders/load-charts-of-accounts.js'

/**
 *
 * @returns
 */
export async function showPageGroupAccounts (params) {
  console.log('showPageGroupAccounts')

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Chart of Accounts:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  const appAccountId = browserAppAccount.data.appAccount.id

  const [chartOfAccountResponse, associatedChartOfAccountsResponse] = await Promise.all([
    loadChartOfAccounts(appAccountId),
    loadAssociatedChartOfAccounts(appAccountId)
  ])
  // TODO Load group accounts

  showMenu()

  showTableChartsOfAccounts(chartOfAccountResponse, associatedChartOfAccountsResponse, browserAppAccount)
}

async function loadAssociatedChartOfAccounts (appAccountId) {
  const response = await callApi('/api/intercompany/:appAccountId/associated-chart-of-accounts', { appAccountId })
  return response
}
